export default __webpack_public_path__ + "static/media/p1050340.6b63985a-min.5aaa5d89.jpg";